import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import RsTableHeaderSortControl from '@Pages/RetroSynthesis/components/RsTable/RsTableHeaderSortControl';
import RsTableHeaderLabel from '@Pages/RetroSynthesis/components/RsTable/RsTableHeaderLabel';
import { Button as LButton } from '@els/els-react--button';
import { TooltipConstants } from '@Components/Tooltip';
import HoverTooltip from '@Components/HoverTooltip';
import { isAnyPredictiveRetrosynthesisAvailable } from '../../predictiveUtils';

import './ProjectTableHeader.scss';

function ProjectTableHeader({ className, sort, onSortChange, onToggleParamsDisplay, showParams = false }) {
  return (
    <tr className={cn('c-els-table__row c-els-table__row--head c-els-table__row--sticky', className)}>
      <th className="c-els-table__cell c-els-table__basic-cell c-els-table__cell--header">
        <RsTableHeaderLabel />
      </th>
      <th className="c-els-table__cell c-els-table__basic-cell c-els-table__cell--header number-th">
        <RsTableHeaderSortControl sortList={sort} sortParam="id" onChange={onSortChange}>
          Number
        </RsTableHeaderSortControl>
      </th>
      <th
        scope="col"
        className="c-els-table__cell c-els-table__basic-cell c-els-table__cell--header number-th"
        aria-description="This column shows the date the project was created.">
        <RsTableHeaderSortControl sortList={sort} sortParam="modified" onChange={onSortChange}>
          Date
        </RsTableHeaderSortControl>
      </th>
      <th className="c-els-table__cell c-els-table__basic-cell c-els-table__cell--header">
        <RsTableHeaderSortControl sortList={sort} sortParam="name" onChange={onSortChange}>
          Project name
        </RsTableHeaderSortControl>
      </th>
      <th className="c-els-table__cell c-els-table__basic-cell c-els-table__cell--header">
        <RsTableHeaderLabel>Target Molecule</RsTableHeaderLabel>
      </th>
      <th
        aria-description=" These parameters are based on your settings from the previous page."
        className={cn(
          'c-els-table__cell c-els-table__basic-cell c-els-table__cell--header c-els-table__cell--header params',
          !showParams && 'params--collapsed',
          'interactive'
        )}>
        <RsTableHeaderLabel
          sublabels={showParams && isAnyPredictiveRetrosynthesisAvailable() ? ['Predicted parameters', 'Published parameters'] : null}>
          <HoverTooltip
            id={TooltipConstants.ids.Retrosynthesis}
            tag="div"
            place="bottom"
            tooltip={`${showParams ? 'Close' : 'Show'} parameters`}
            theme="simple"
            className="toggle-project-params-tooltip u-els-font-size-base">
            <LButton
              aria-label={`${showParams ? 'Close' : 'Show'} parameters`}
              type="tertiary"
              onClick={onToggleParamsDisplay}
              size="x-small"
              className="params__toggle-btn-i">
              <svg className="els-btn-icon els-btn-icon-tiny">
                <use xlinkHref={showParams ? '#icon-chevron-right' : '#icon-chevron-left'} />
              </svg>
            </LButton>
          </HoverTooltip>
          {!showParams || isAnyPredictiveRetrosynthesisAvailable() ? null : 'Parameters'}
        </RsTableHeaderLabel>
      </th>
      <th className="c-els-table__cell c-els-table__basic-cell c-els-table__cell--header c-els-table__cell--header">
        <RsTableHeaderLabel>Number of routes</RsTableHeaderLabel>
      </th>
    </tr>
  );
}

ProjectTableHeader.defaultProps = {
  onToggleParamsDisplay: () => {},
};

ProjectTableHeader.propTypes = {
  sort: PropTypes.array,
  // sortProperty: PropTypes.func,
  showParams: PropTypes.bool,
  onToggleParamsDisplay: PropTypes.func,
  className: PropTypes.string,
  onSortChange: PropTypes.func,
};

export default ProjectTableHeader;
